import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import axios from "axios";

const OfertaCard = ({ oferta, user, isFavorite, onFavoriteToggle, likes = 0 }) => {
  const { currentUser, getFreshToken } = useAuth();
  const [imageError, setImageError] = useState(false);
  const navigate = useNavigate();

  // Helper to safely format currency
  const formatPrice = (value) => {
    if (value === undefined || value === null) return "R$ --";
    return `R$ ${Number(value).toFixed(2)}`;
  };

  // Helper to calculate discount safely
  const getDiscountPercentage = () => {
    if (!oferta.precoOriginal || !oferta.precoDesconto) return 0;
    return Math.round(
      ((oferta.precoOriginal - oferta.precoDesconto) / oferta.precoOriginal) * 100
    );
  };

  const handleOfferClick = async (e) => {
    // Tentar pontuar pelo clique e registrar visualização
    try {
      const token = currentUser ? await getFreshToken() : null;
      
      const requests = [
        axios.post(`${process.env.REACT_APP_API_URL}/offers/${oferta.id}/view`),
        // Rastrear interesse por categoria localmente
        (async () => {
          if (oferta.categoria) {
            const interests = JSON.parse(localStorage.getItem('categoryInterests') || '{}');
            interests[oferta.categoria] = (interests[oferta.categoria] || 0) + 1;
            localStorage.setItem('categoryInterests', JSON.stringify(interests));
          }
        })()
      ];

      if (token) {
        requests.push(
          axios.post(`${process.env.REACT_APP_API_URL}/wallet/click-reward`,
            { offerId: oferta.id },
            { headers: { Authorization: `Bearer ${token}` } }
          )
        );
      }

      Promise.all(requests).catch(console.error);
      
    } catch (error) {
      console.error("Erro ao registrar interações:", error);
    }
  };

  const discountPercentage = getDiscountPercentage();
  const precoOriginal = oferta.precoOriginal;
  const precoDesconto = oferta.precoDesconto;
  const imageSrc = oferta.imagem || oferta.imagem_url;

  if (imageError || !imageSrc) return null;

  return (
    <div style={{
      backgroundColor: 'var(--background-white)',
      borderRadius: 'var(--radius-md)',
      overflow: 'hidden',
      transition: 'all 0.2s ease',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      position: 'relative',
      border: '1px solid transparent',
      cursor: 'pointer'
    }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 7px 16px 0 rgba(0,0,0,0.11)';
        e.currentTarget.style.borderColor = 'rgba(0,0,0,0.05)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.borderColor = 'transparent';
      }}
    >
      {/* Favorite Button */}
      <button
        onClick={(e) => {
          e.preventDefault();
          onFavoriteToggle(oferta.id);
        }}
        style={{
          position: 'absolute',
          top: '8px',
          right: '8px',
          background: 'rgba(255, 255, 255, 0.9)',
          border: 'none',
          borderRadius: '50%',
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          zIndex: 2,
          transition: 'all 0.2s',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.background = 'white';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.9)';
        }}
      >
        <i className={isFavorite ? "fas fa-heart" : "far fa-heart"} style={{
          color: isFavorite ? 'var(--accent-color)' : 'var(--text-secondary)',
          fontSize: '16px'
        }}></i>
      </button>

      <Link
        to={`/oferta/${oferta.id}`}
        onClick={handleOfferClick}
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        {/* Image Container */}
        <div style={{
          width: '100%',
          paddingTop: '85%',
          position: 'relative',
          backgroundColor: '#fff',
          overflow: 'hidden',
          borderBottom: '1px solid #eee'
        }}>
          <img
            src={imageSrc}
            alt={oferta.titulo}
            onError={() => setImageError(true)}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              padding: 'var(--spacing-sm)'
            }}
          />

          {/* Like Badge */}
          <div style={{
            position: 'absolute',
            bottom: '8px',
            right: '8px',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            padding: '4px 8px',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            fontSize: '11px',
            fontWeight: 'bold',
            color: 'var(--text-secondary)',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            zIndex: 1
          }}>
            <i className="fas fa-thumbs-up" style={{ color: 'var(--primary-color)' }}></i>
            {likes}
          </div>
        </div>

        {/* Content */}
        <div style={{
          padding: '16px',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          gap: '8px'
        }}>
          <div>
            <span style={{
              fontSize: '11px',
              color: '#888',
              textTransform: 'uppercase',
              fontWeight: '700',
              letterSpacing: '0.05em'
            }}>
              {oferta.loja}
            </span>
          </div>

          <div style={{ marginTop: '4px' }}>
            <h3 style={{
              fontSize: '14px',
              color: '#666',
              margin: '0 0 6px 0',
              lineHeight: '1.25',
              fontWeight: '400',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              height: '35px',
              fontFamily: 'var(--font-main)',
              letterSpacing: '0'
            }}>
              {oferta.titulo}
            </h3>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
              {precoOriginal > precoDesconto && (
                <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '12px' }}>
                  {formatPrice(precoOriginal)}
                </span>
              )}
              
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', marginTop: '2px' }}>
                <span style={{ 
                  fontSize: '24px', 
                  fontWeight: '500', 
                  color: '#333',
                  fontFamily: 'var(--font-main)'
                }}>
                  {formatPrice(precoDesconto)}
                </span>
                {discountPercentage > 0 && (
                  <span style={{
                    color: '#00a650',
                    fontSize: '14px',
                    fontWeight: '400'
                  }}>
                    {discountPercentage}% OFF
                  </span>
                )}
              </div>

              {oferta.mostrar_parcelamento !== false && precoDesconto && (
                <div style={{ fontSize: '14px', color: '#00a650', fontWeight: '400', marginTop: '2px' }}>
                  10x {formatPrice(Number(precoDesconto) / 10)} sem juros
                </div>
              )}

            </div>
          </div>
        </div>
      </Link>

    </div>
  );
};

export default OfertaCard;
